import { render, staticRenderFns } from "./PartnerTire.vue?vue&type=template&id=b0e52ff4&scoped=true"
import script from "./PartnerTire.vue?vue&type=script&lang=js"
export * from "./PartnerTire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e52ff4",
  null
  
)

export default component.exports